module.exports = __webpack_public_path__ + "static/img/al-top.f7b5a828.png";